/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useState } from "react";
import MppModalHeader from "./MppModalHeader";
import MppModalBody from "./MPPModalBody";
import MppModalFooter from "./MppModalFooter";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  GlobalErrorPage,
  MerchantPriceErrorPage,
} from "../../container/globalError/GlobalErrorPage";
import PendingStatusPage from "../MppPrequalApplyStatus/PendingStatusPage";
import ProductInfo from "./ProductInfo";
import { ThemeContext } from "../../container/mppmodal/MppInfo";
import PriceInput from "./PriceInput";
import { D2DmppPage } from "./D2DmppPage";
import { D2DmppErrorPage } from "./D2DmppErrorPage";

const mppModal = () => {
  const [isStandardOffer, setIsStandardOffer] = useState(false);
  const [isApplyOffer, setIsApplyOffer] = useState(false);
  const [isSetPayOffer, setIsSetPayOffer] = useState(false);
  const [isSetPayIn4Offer, setIsSetPayIn4Offer] = useState(false);
  const [isSuccessPageMppApplication, setSuccessPageMppApplication] = useState(false);
  const [errorPageMppApplication, setErrorPageMppApplication] = useState(false);

  const {
    isMerchantApiFailed,
    isCheckoutDataApiFailed,
    isWebviewTokenValidationFailed,
    applyPrequalPendingStatus,
    offers,
    flowType,
    queryValues: { d2dFlow, amount, authorizationNumber },
    showMppAmountInputBox,
    ProductDetails,
    brandings: { availableOffersText },
    offersDetails,
  } = useContext(ThemeContext);

  const d2dMppLinkProps = {
    setSuccessPageMppApplication,
    setErrorPageMppApplication,
    errorPageMppApplication
  }

  const getOfferType = (offers) => {
    let offerType = [];
    // eslint-disable-next-line no-unused-expressions
    Object.entries(offers).filter((offerDesc) => {
      return offerType.push(offers[0].offerType);
    });

    if (offerType.includes("PPPP")) {
      setIsStandardOffer(true);
    }

    if (
      offerType.includes("FPRR") ||
      offerType.includes("WPDI") ||
      offerType.includes("EPNI") ||
      offerType.includes("EPNIIO")
    ) {
      setIsApplyOffer(true);
    }

    if (offerType.includes("SetPAY")) {
      setIsSetPayOffer(true);
    }

    if (offerType.includes("SetPAYIn4")) {
      setIsSetPayIn4Offer(true);
    }
  };
  const handleMppModalBody = () => {
    if (ProductDetails) {
      return <ProductInfo />
    }
    else if (offersDetails && isSuccessPageMppApplication) {
      return <D2DmppPage {...d2dMppLinkProps} />
    }
    else if (errorPageMppApplication) {
      return <D2DmppErrorPage />
    }
    else if (offersDetails) {
      return (<MppModalBody offersType={offersType} />)
    } else {
      return (
        <div className="modal-body modal-offer-content" role="status" aria-live="polite">
          <>
            <h1 className="bodayHeader mb-1">
              <b>
                {" "}
                {availableOffersText}
                {!(flowType === "PDP" && showMppAmountInputBox === "Y") &&
                  amount && <> ${parseFloat(amount).toFixed(2) || 0}</>}
              </b>
            </h1>
            <h1 className="availableSub-heading mt-0">
              See if you Prequalify for available options with no impact
              to your credit bureau score
            </h1>
            {flowType === "PDP" && showMppAmountInputBox === "Y" && (
              <>
                <PriceInput setOffersDisplay={() => { }} />
              </>
            )}
          </>
        </div>
      )
    }
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    getOfferType(offers);
  }, [offers]);

  const offersType = { isStandardOffer, isApplyOffer, isSetPayOffer };

  let element;

  if (
    isMerchantApiFailed &&
    (["CHECKOUT", "CART"].includes(flowType) ||
      ((d2dFlow === "Y" || authorizationNumber) && ["PDP"].includes(flowType) && showMppAmountInputBox !== "Y"))
  ) {
    element = <MerchantPriceErrorPage />;
  } else if (isCheckoutDataApiFailed || isWebviewTokenValidationFailed) {
    element = <GlobalErrorPage d2dFlow={d2dFlow} />;
  } else {
    element = (
      <>
        <MppModalHeader />
        {applyPrequalPendingStatus === "Pending" ? (
          <PendingStatusPage />
        ) : (
          <>
            {handleMppModalBody()}
          </>
        )}
        <MppModalFooter {...d2dMppLinkProps} />
      </>
    );
  }

  return <React.Fragment>{element}</React.Fragment>;
};

export default mppModal;
